var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronBottom = function SvgChevronBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.502 6.623c0-.158.058-.317.183-.442a.629.629 0 0 1 .884 0l6.183 6.184 6.183-6.184a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .884l-6.317 6.316a1.066 1.066 0 0 1-1.508 0L2.677 7.065a.618.618 0 0 1-.183-.442h.008Z",
    fill: "current"
  })));
};
export default SvgChevronBottom;